import { API_URL_MAIN } from '@/config';
import { axios } from '@/lib/axios';

export type I_SetNewPassword = {
  new_password: string;
  url_token: string;
};

export const setNewPassword = (data: I_SetNewPassword) => {
  return axios.post(`${API_URL_MAIN}/set_new_password`, data,
  );
};
